import { render, staticRenderFns } from "./ModalCreateProduct.vue?vue&type=template&id=30d0ee1a"
import script from "./ModalCreateProduct.vue?vue&type=script&lang=js"
export * from "./ModalCreateProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports